import React, { useMemo } from 'react';
import { ContractActions } from '../types';
import EnableDisable from './EnableDisable';
import ContractBlockCRR from './BlockCRR';

interface Props {
  action: ContractActions;
  visibleState: any;
  onOk?: Function;
  onCancel?: Function;
  onFinish?: Function;
  selectedContracts?: any;
  isOpen: boolean;
  onClose?: Function;
}

function ContractActionsModal(props: Props) {
  const {
    action,
    visibleState,
    onCancel,
    onFinish,
    selectedContracts,
    isOpen,
    onClose,
  } = props;

  const actionMap = useMemo(() => {
    const dictionary: { [key: string]: any } = {
      visibility: (
        <EnableDisable
          selectedContracts={selectedContracts}
          isOpen={isOpen}
          onClose={onClose}
          onFinish={onFinish}
        />
      ),
      crrBlock: (
        <ContractBlockCRR
          selectedContracts={selectedContracts}
          visibleState={visibleState}
          onFinish={onFinish}
          onCancel={onCancel}
        />
      ),
    };
    if (action && dictionary[action]) {
      return dictionary[action];
    }
    return [];
  }, [
    selectedContracts,
    isOpen,
    onClose,
    onFinish,
    visibleState,
    onCancel,
    action,
  ]);

  return actionMap;
}

export default React.memo(ContractActionsModal);
